import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, DeleteModal, Heading, Toggle } from '../../components';
import { Link } from 'react-router-dom';
import { ReactComponent as EditIcon } from '../../assets/icons/create.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/trash.svg';
import { useState } from 'react';
import './style.scss';
import { ParentView, RegionView } from './Views';
import SiteView from './Views/SiteView';
import { Stack } from '@mui/material';
import { updatePromotion } from '../../store/actions/promotions-and-sales';
import { addError, addNotification, beablooApi } from '../../utils';
import removePending from '../../utils/removePending';
import addPending from '../../utils/addPending';
import { set } from 'lodash';
import promotionService from '../../lib/signtouch/promotionServices';

export const Promotion = ({ id, name, isParent, isRegion ,belongsTo,promotionToggle }) => {
  const [isPendingRequest, setIsPendingRequest] = useState(false);
  const promotion= useSelector((state) => state.promotions).find((promo) => parseInt(promo.id) === parseInt(id));
  const [isEnabled, setIsEnabled] = useState(promotion?.enablePromotion ?? promotionToggle ?? true);
  const { currentDevelopment } = useSelector((state) => state.general);
  const { type } = currentDevelopment;
  const { developmentId } = useParams();
  const dispatch = useDispatch();
  
  const toggleIsPendingRequest = () =>
    setIsPendingRequest((state) => {
      return !state;
    });
   

  const hasPermission = () => {
    if (belongsTo === currentDevelopment.id) return true;
    return false;
  };

  const handleToggleUpdate = async (newValue) => {
    const pendingId = addPending('Updating Promotion');
    const payload = {
      enablePromotion: newValue,
    };

    promotionService.promotionUpdate(payload, belongsTo, id).then((r) => {
      setIsEnabled(newValue);
      removePending(pendingId);
      return r;
    }).then((r) => {
      dispatch(updatePromotion({ ...r, belongsTo: belongsTo, enablePromotion: newValue }))
    }).then(() => addNotification('Updated Promotion'))
    .catch((e) => {
      addError(e.message);
    });

  };

  const handleChange = (e) => {
    const newValue = e;
    setIsEnabled(newValue);
    handleToggleUpdate(newValue);

  };

  return (
    <>
      <div className='promotion'>
        <div className='promotions-list-item'>
          <div className='promotion-details'>
            <h4>{name}</h4>
          </div>
          <div className='promotion-links'>
          {hasPermission() && (
            <>
              <Link
                to={`/developments/${belongsTo}/promotions-sales-methods/${id}`}
                >
                <EditIcon />
              </Link>
              <div className='delete-promotion' onClick={toggleIsPendingRequest}>
                <DeleteIcon />
              </div>
            </>
            )}
          </div>
        </div>
        <div className='promotion-toggle' >
          <Toggle initialValue={isEnabled} onChange={handleChange} disabled={type === 'signtouch-region' && isParent}
          />
        </div>
      </div>

      {isPendingRequest && (
        <DeleteModal
          type='promotion'
          objectName='Promotion'
          options={{ id: id }}
          closeModal={toggleIsPendingRequest}
        />
      )}
    </>
  );
};

const PromotionsAndSalesMethods = () => {
  // DevelopmentID
  const { developmentId } = useParams();
  const { currentDevelopment } = useSelector((state) => state.general);

  // Promotions and Sales methods

  return (
    <div className={'page-padding promotions-and-sales-methods'}>
      <div className='heading-with-button'>
        <Heading label='Promotions' />
        <Link
          to={`/developments/${developmentId}/promotions-sales-methods/create`}
        >
          <Button label={'create promotion'} />
        </Link>
      </div>

      {currentDevelopment.type == 'signtouch-parent' && <ParentView />}

      {currentDevelopment.type == 'signtouch-region' && <RegionView />}

      {currentDevelopment.type == 'signtouch-site' && <SiteView />}
    </div>
  );
};

export default PromotionsAndSalesMethods;
